export interface Phase {
  key: string;
  value: string;
}

export interface WorkprogramPhase {
  key: string;
  value: string;
}

export interface Environment {
  name: string;
  url: string;
}

export interface Config {
  CLIENT_ID: string;
  AUTH_URL: string;
  ENVIRONMENTS: Environment[];
  PHASES: Phase[];
  WORKPROGRAM_PHASES: WorkprogramPhase[];
  SINGLE_ENGAGEMENT_FORMULA_CACHING_TIME: number;
  MULTI_ENGAGEMENT_FORMULA_CACHING_TIME: number;
  ENUM_PARAMETERS_CACHING_TIME: number;
  MAX_FORMULA_RECURSION_DEPTH: number;
}

export enum Period {
  Current = "Current",
  Prior = "Prior",
}

export enum Level {
  Classification = "Classification",
  Category = "Category",
  SubCategory = "SubCategory",
  Account = "Account",
  EntityId = "EntityID",
}

export enum BalanceType {
  Original = "Original",
  Adjustments = "Adjustments",
  Adjusted = "Adjusted",
}

export enum Materiality {
  Overall = "Overall",
  Performance = "Performance",
  Trivial = "Trivial",
}

export enum ResponseSelection {
  Name = "Name",
  Justification = "Justification",
  User = "User",
  Time = "Time",
}

export interface FormulaNodeDetails {
  formulaExpression: string | null;
  value: string | null;
  isOverriding?: boolean;
}

export interface InsertEngagementPhaseModalBase {
  environment: Environment;
  engagementId: string;
  phase: Phase;
}

export interface InsertOLSModalOutput extends InsertEngagementPhaseModalBase {
  autofitColumnWidths: boolean;
  entityId?: string;
}

export interface InsertMFDModalOutput extends InsertEngagementPhaseModalBase {
  generalFund?: string[];
  specialRevenueFunds?: string[];
  debtServiceFunds?: string[];
  capitalProjectsFunds?: string[];
  permanentFunds?: string[];
}

export interface InsertEngagementDetailsModalOutput {
  environment: Environment;
  engagementId: string;
}

export interface InsertProcedureOrResponseModalOutput {
  environmentName: string;
  engagementId: string;
  workprogramPhaseName: string;
  workprogramSectionId: string;
  workprogramId: string;
  procedureSectionId: string;
  procedureId: string;
  responseId?: string;
  responseSelection?: string;
}

export enum BuiltFilePaths {
  Taskpane = "/taskpane.html",
  Auth = "/Index.html",
  SignInRedirect = "/RedirectTest.html",
  SilentRenew = "/SilentRenew.html",
}

export enum QueryParamKeys {
  Signout = "signout",
  Window = "window",
  Formula = "formula",
  Value = "value",
  /** Passed to the auth dialog so the IdP can pre-fill the account (OIDC `login_hint`). */
  LoginHint = "login_hint",
}

export enum QueryParamWindowValues {
  CustomModel = "customModel",
  TBBreakdownModal = "TBBreakdownModal",
  InsertTemplate = "InsertTemplate",
  InsertMFD = "InsertMFD",
  EngagementSummaryModal = "EngagementSummaryModal",
  InsertEngagementDetails = "InsertEngagementDetails",
  InsertEditProcedureOrResponseModal = "InsertEditProcedureOrResponseModal",
}

export enum LinkedEntityCellTypes {
  SingleEngagementDetails = "singleEngagementDetails",
  Procedures = "procedures",
  Responses = "responses",
}

export enum DialogState {
  DialogReady = "DIALOG_READY",
}
